import { useEffect, useRef } from 'react'
import { LoadingStates } from '@dashboard/lib/types'

export function useOnSuccess(
  states: LoadingStates[],
  callback: () => void,
): void {
  const prevStates = useRef(states)

  useEffect(() => {
    if (
      states.length > 0 &&
      prevStates.current.some(s => s === 'loading') &&
      states.every(s => s === 'success')
    ) {
      callback()
    }

    prevStates.current = states
  }, [...states])
}
